import { render, staticRenderFns } from "./fail.vue?vue&type=template&id=1bd422bd&scoped=true"
import script from "./fail.vue?vue&type=script&lang=js"
export * from "./fail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd422bd",
  null
  
)

export default component.exports